import React from "react";

const ProgressBar = ({ className, percentage, style }) => (
  <div
    className={className}
    style={{ width: `${percentage}%`, ...(style || {}) }}
  />
);

export default ProgressBar;
